import icon from './topic_momentum.png.js';
import template from './momentum_widget_view.html';
import templateMaxView from './momentum_widget_max.html';
import templateReportView from './momentum_widget_report.html';
angular
    .module('MW.InsDashboard.MomentumD3',[
        'CoreColorService',
        'MW.Framework.TranslationService',
        'MW.Dashboard.DashboardStateService',
        'MW.InsDashboard.insightsBackendService',
        'MW.Framework.AppChromeService',
        'MW.Configuration'])
    .directive('momentumD3',['CoreColorService', 'translationService', 'DashboardStateService', function(CoreColorService, translationService) {
    'use strict';

    return {
        template: '<div><div ng-if="chartData.isMaximized" class="bubbleTooltip mouse" style="position: absolute"></div></div>',
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            chartData: '=data',
            drill: '&drill',
            isMaximized: '=maximized',
            chartType: '=',
            isReport: '=?',
            exportType: '=?',
            selected: '=?'
        },

        controller: ['$scope',function(scope) {

            scope.initState = function(){

                scope.height = 0;
                scope.width = 0;
                scope.isMaximized = false;
                scope.element = null;
                scope.svg = null;
                scope.min = 0;
                scope.max = 0;

                //Bubble Chart settings
                scope.volumeFontSize = 2;
                scope.collisionPadding = 10;
                scope.minCollisionRadius = 25;
                scope.maxLabelLineLengthMaximized = 13;
                scope.maxLabelLineLengthWidget = 10;
                scope.fGravity = -0.01;
                scope.fFriction = 0.1;
                scope.minKeyFontSize = 10;
                scope.maxKeyFontSize = 25;
                scope.x = 33;

                scope.fontSizeMaxView = 12;
                scope.fontSizeDashboardView = 10;

                //Bubble Chart properties initialized on creation
                scope.maxBubblesInDashboard = 0;
                scope.maxBubblesInMaxView = 5;
                scope.maxRadius = 0;
                scope.minxRadius = 0;
                scope.maxLabelLineLength = 0;

                scope.disabledBubbleOpacity = 0.05;
                scope.bubble = d3.layout.pack();
                scope.force = d3.layout.force();
                scope.keyFontScale = false;

                scope.rScale = function() { return scope.maxRadius; };
            };

            scope.createVisualization = function (vType, data, element, isMaximized, clickOnWordFunc) {
                data.children = data.children.slice(0, scope.chartData.numOfBubbles);
                scope.initState();
                scope.element = element;
                scope.isMaximized = isMaximized;
                scope.click = clickOnWordFunc;
                scope.height = 223;

                // Analyze-web sometimes has trouble finding the correct width of the elements depending on the timing.
                // This series of OR operators is to select a proper default value in these cases.
                // IMPORTANT: Setting to 700 by default is needed for reports to render correctly in wkhtmltopdf.
                scope.width =
                    scope.element[0].clientWidth
                    || scope.element[0].parentNode.clientWidth
                    || scope.element[0].parentNode.parentNode.clientWidth
                    || 700;

                scope.max = Math.max.apply(Math,data.children.map(function(o){ return o.value; }));
                scope.min = Math.min.apply(Math,data.children.map(function(o){return o.value;}));

                if (scope.isMaximized) {
                    scope.height = 500;
                }
                if(scope.isReport && typeof scope.isReport !== 'function') {
                    //IMPORTANT: Setting to 700 by default is needed for reports to render correctly in wkhtmltopdf.
                    scope.width = 700;
                    if(scope.exportType === 'widgetImage') {
                        scope.width = 1150;
                    }
                }

                scope.data = data;
                //Set the filter on the data to only show the top 7 words on the dashboard view
                //currently the max view is being handled on the backend call. We may want to consider updating scope
                //here in the future so we have more control for different views and have it evaluated based on view but,
                //currently it is not required.
                var dataFilter = {
                    maxWords: {
                        userView: 7,
                        maxView: 12
                    }
                };

                if (scope.svg === null || !data.isUpdate) {
                    scope.initBubbleCloud(data, dataFilter);
                }
                scope.createBubbleCloud(data);
            };

            //Functions supporting bubble chart
            scope.gravity = function gravity(alpha) {
                var ax, ay, cx, cy;
                cx = scope.width / 2;
                cy = scope.height / 2;
                ax = alpha / 2;
                ay = alpha;
                return function (d) {
                    d.x += (cx - d.x) * ax;
                    return d.y += (cy - d.y) * ay * 3;
                };
            };

            scope.collide = function collide() {
                return function (d) {
                    return scope.node.each(function (d2) {
                        var distance, minDistance, moveX, moveY, x, y;
                        if (d !== d2) {
                            x = d.x - d2.x;
                            y = d.y - d2.y;
                            distance = Math.sqrt(x * x + y * y);
                            var dforceR = Math.max(scope.minCollisionRadius, scope.rScale(d.value));
                            var d2forceR = Math.max(scope.minCollisionRadius, scope.rScale(d2.value));
                            minDistance = dforceR + d2forceR + scope.collisionPadding; //+ d.out/2 + d2.out/2;
                            if (distance < minDistance) {
                                distance = (distance - minDistance) / distance * 0.4;
                                moveX = x * distance;
                                moveY = y * distance/scope.horizontalSpacingFactor;
                                d.x -= moveX;
                                d.y -= moveY;
                                d2.x += moveX;
                                d2.y += moveY;
                            }
                        }
                    });
                };
            };

            scope.tick = function tick(e) {
                scope.node.each(scope.gravity(e.alpha * 0.1))
                    .each(scope.collide())
                    .attr('transform', function (d) {
                        return 'translate(' + Math.max(d.r*1.7 , Math.min(scope.width - d.r*1.7, d.x)) + ',' + Math.max(d.r*1.7 , Math.min(scope.height - d.r*1.7, d.y)) + ')';
                    });
            };

            var generateLegends = function() {

                var preExistingOpacity = 0.55;

                var canvasCenter = scope.width / 2 - 110;


                var legendData = [
                    {'title': translationService.getLocalizedString('New'),enabled: 1},
                    {'title': translationService.getLocalizedString('Pre-existing'), enabled: 1},
                    {'title': translationService.getLocalizedString('Vanished'), enabled: 1},
                    {'title': translationService.getLocalizedString('Selected'), enabled: 1}
                ];
                var legendItems = scope.svg.selectAll('g.legendItem')
                    .data(legendData)
                    .enter()
                    .append('g')
                    .attr("transform", function(d, i) {
                        if(i === 2) {
                            return "translate(" + (i * 85 + canvasCenter - 60) + ", " + (scope.height - 20) + ")";
                        } else if(i === 3) {
                            return "translate(" + (i * 85 + canvasCenter - 60) + ", " + (scope.height - 20) + ")";
                        }
                        return "translate(" + (i * 70 + canvasCenter - 60) + ", " + (scope.height - 20) + ")";
                    })
                    .classed('legendItem', true)
                    .style('cursor', 'pointer')
                    .on('click', function(d, i) {
                        var el = d3.select(this);

                        if(d.enabled == 1) {
                            if(i !== 3) {
                                el.select('circle.circle').style('fill', CoreColorService.colors.grey20);
                                el.select('circle.circle').style('stroke', CoreColorService.colors.grey20);
                                el.select('text.tile').style('fill', CoreColorService.colors.grey20);
                            }
                            if(i == 1)
                                el.select('circle.circle').style('opacity', 1);

                            /* opacity to scope.disabledBubbleOpacity in case the legend item is clicked to hide the correspoding bubbles */
                            scope.node
                                .filter(function(d) {
                                    if(i === 0)
                                        return d.change == 100;
                                    else if(i === 2)
                                        return d.change == -100;
                                    else if(i === 3) {
                                        return d.selected == 1;
                                    }
                                    return (d.change != 100 && d.change != -100);
                                })
                                .style("opacity", scope.disabledBubbleOpacity);
                            d.enabled = 0;
                        } else {
                            if(i === 2) {
                                el.select('circle.circle').style('fill', CoreColorService.colors.grey3);
                            } else if(i === 1) {
                                el.select('circle.circle').style('fill', CoreColorService.colors.blueMalibu);
                                el.select('circle.circle').style('opacity', preExistingOpacity);
                            } else if(i === 0) {
                                el.select('circle.circle').style('fill', CoreColorService.colors.blueMalibu);
                            }
                            el.select('text.title').style('fill', CoreColorService.colors.grey80);

                            scope.node
                                .filter(function(d) {
                                    if(i === 0)
                                        return d.change == 100;
                                    else if(i === 2)
                                        return d.change === -100;
                                    return (d.change != 100 && d.change != -100);
                                })
                                .style("opacity", 1.0);
                            d.enabled = 1;
                        }
                    });

                legendItems
                    .append('circle')
                    .attr('r', 10)
                    .attr('class', 'circle')
                    .style('stroke-width', function(d, i) {
                        if(i === 2 || i === 3)
                            return 1;
                        return 0;
                    })
                    .style('stroke', function(d, i) {
                        if(i === 3) {
                            return CoreColorService.colors.blueMalibu;
                        } else if(i === 2) {
                            return CoreColorService.colors.grey20;
                        }
                    })
                    .style('fill', function(d, i) {
                        if(i === 3) {
                            return CoreColorService.colors.white
                        } else if(i === 2)
                            return CoreColorService.colors.grey3;
                        return CoreColorService.colors.blueMalibu;
                    })
                    .style('opacity', function(d, i) {
                        if(i === 1)
                            return preExistingOpacity;
                        return 1.0;
                    });

                legendItems
                    .append('text')
                    .attr('class', 'title')
                    .text(function(d) {
                        return d.title;
                    })
                    .style('font-weight', '400')
                    .style('fill', CoreColorService.colors.grey80)
                    .attr('y', 5)
                    .attr('x', 18)
                    .attr('font-size',11);
            };

            scope.initBubbleCloud = function(data,dataFilter){
                if(!scope.isMaximized){
                    scope.height = parseInt(scope.element[0].parentNode.clientHeight || $(window).height());
                    scope.width = parseInt(scope.element[0].parentNode.clientWidth || $(window).width());
                }
                scope.horizontalSpacingFactor=1;
                if(scope.width>870) {
                    scope.horizontalSpacingFactor=3;
                    scope.collisionPadding = 20;
                }
                else if(scope.width>750) {
                    scope.horizontalSpacingFactor=2.2;
                    scope.collisionPadding = 20;
                }

                if (scope.width > 350 && scope.height > 241 ) {
                    scope.minxRadius = scope.isMaximized ? 25 : ((Math.sqrt((scope.width*scope.height) / (Math.PI))) / 6);
                } else if (scope.width > 350 && scope.height < 240 ) {
                    scope.minxRadius = scope.isMaximized ? 25 : ((Math.sqrt(((scope.width*scope.height)) / (Math.PI))) / 5);
                } else {
                    scope.minxRadius = scope.isMaximized ? 25 : 30;
                }

                scope.maxBubblesInDashboard      = dataFilter.maxWords.userView;
                scope.maxBubblesInMaxView        = dataFilter.maxWords.maxView;
                scope.maxRadius                  = scope.isMaximized ? 50 : 35;
                scope.maxLabelLineLength         = scope.isMaximized ? scope.maxLabelLineLengthMaximized : scope.maxLabelLineLengthWidget;

                scope.keyFontScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minKeyFontSize, scope.maxKeyFontSize]);
                if(scope.min != scope.max) {
                    scope.rScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minxRadius, scope.maxRadius]);
                }


                // scope next loop goes through all of the various words, and calculates the diameter of the circle with the rScale function.
                // It then turns scope into the area of a square, and adds it to a running total.
                var combinedArea = 0;

                angular.forEach(data.children, function forEachData(point) {
                    var scopeDiameter = 1.9 *scope.rScale(point.value),
                        scopeArea = scopeDiameter*scopeDiameter;
                    combinedArea += scopeArea;
                });

                var availableArea = scope.width * scope.height;
                // Next, if the combined area of the squares is larger than the area of the rectangle we're fitting the circles into
                if (combinedArea > availableArea) {
                    // Scale the radius of the points down by some factor based off the width of the circles.
                    // Note: scope scaling factor is a little arbitrary, and may be tweakable. It seems to work alright if all 9 values in a small content stream are the same.
                    var scalingOffset = availableArea/combinedArea;
                    if(scope.min != scope.max) {
                        scope.rScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minxRadius, scope.maxRadius*scalingOffset]);
                    }
                    scope.keyFontScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minKeyFontSize, scope.maxKeyFontSize*scalingOffset]);
                }

                scope.bubble = d3.layout.pack()
                    .sort(function(a, b) { return d3.descending(a.value, b.value); })
                    .size([scope.width, scope.height - 200])
                    .padding(10)
                    .value(function(d) { return (d.value); });

                scope.force = d3.layout.force()
                    .gravity(scope.fGravity)
                    .friction(scope.fFriction)
                    .charge(function (d) {
                        return Math.pow(d.r, 2.0) / 8;
                    })
                    .size([scope.width, scope.height])
                    .on('tick', scope.tick);

                d3.select(scope.element[0]).selectAll('svg').remove();

                scope.svg = d3.select(scope.element[0])
                    .append('svg')
                    .attr('width', scope.width)
                    .attr('height', scope.height)
                    .attr('class', 'bubble')
                    .attr('viewBox', '0 0 ' + scope.width + ' ' + scope.height )
                    .attr('preserveAspectRatio', 'xMidYMid slice');
            };

            scope.createBubbleCloud = function(data){


                var elementPosition = scope.element[0].getBoundingClientRect(); // Relative position of the container to calculate tooltip position on 'mousemove'

                if(scope.isMaximized)
                    generateLegends();

                data.name = 'keyphrases';

                var tooltip =  d3.select("div.bubbleTooltip.mouse");


                for(var i = 0; i < data.children.length; i++){
                    data.children[i].name = data.children[i].keyphrase;
                }
                scope.force.nodes(data.children).start();

                scope.node = scope.svg.selectAll('.node')
                    .data(scope.bubble.nodes(data)
                        .filter(function (d) { return !d.children;})
                        .filter(function(d,i) {
                            if (!scope.isMaximized) {
                                return i < scope.maxBubblesInDashboard;
                            }
                            else
                            {
                                return i < 12;
                            }
                        }));

                var nodeGroup = scope.node
                    .enter().append('g')
                    .attr('class', 'node')
                    .transition(1000);


                // scope.node.exit().remove();

                var checkDisabled = function(element) {
                    // check if this node is disabled by legend items using the opacity attr
                    var currentOpacity = d3.select(element).style('opacity');
                    if(parseFloat(currentOpacity).toFixed(2) == scope.disabledBubbleOpacity) {
                        return true;
                    }
                    return false;
                }


                scope.node
                    .on('mouseover', function(d, i) {
                        if(checkDisabled(this))
                            return;
                        if(d.change == -100)
                            tooltip.html(translationService.getLocalizedString('Volume') + ': '
                                + d.value + '<br>' +
                                translationService.getLocalizedString('Share of Voice (previous period)') + ': ' + d.oldSOV + '%');
                        else
                            tooltip.html(translationService.getLocalizedString('Volume') + ': '
                                + d.value + '<br>' +
                                translationService.getLocalizedString('Share of Voice (current period)') + ': ' + d.newSOV + '%');

                        tooltip.style("opacity", "1");

                        tooltip
                            .style("left", (window.pageXOffset) + "px")
                            .style("top",  (window.pageYOffset) + "px");

                        d3.select(this).style('opacity', function(d) {
                            return 0.9;
                        });
                    })
                    .on('mouseout', function(d, i) {
                        if(checkDisabled(this))
                            return;

                        tooltip.style("opacity", "0");
                        d3.select(this).style('opacity', function(d) {
                            return 1.0;
                        });
                    })
                    .on('mousemove', function(d, i) {
                        if(checkDisabled(this))
                            return;

                        tooltip
                            .style("left", Math.max(0, d3.event.pageX - elementPosition.left - 70) + "px") // 70 to pad to left
                            .style("top", (d3.event.pageY - elementPosition.top + 30) + "px"); // 30 to pad it down
                    })
                    .append('circle')
                    .style('fill', function(d) {
                        if(scope.selected.indexOf(d.keyphrase) > -1)
                            return CoreColorService.colors.white;
                        if(d.change == -100)
                            return CoreColorService.colors.grey3;
                        return CoreColorService.colors.blueMalibu;
                    })
                    .style('opacity', function(d) {
                        if(d.change != 100 && d.change != -100)
                            return 0.55;
                        return 1.0;
                    })
                    .style('cursor', 'pointer')
                    .style('stroke', function(d) {
                        if(scope.selected.indexOf(d.keyphrase) > -1)
                            return CoreColorService.colors.blueMalibu;
                        if(d.change== -100)
                            return CoreColorService.colors.grey20;
                        return 'none';
                    })
                    .style('stroke-width', function(d) {
                        if(scope.selected.indexOf(d.keyphrase) > -1)
                            return 1;
                        if(d.change == -100)
                            return 1;
                        return 0;
                    })
                    .style("stroke-dasharray", function(d) {
                        return "none";
                    })
                    .attr('class', 'circle')
                    .attr('data-classname', function (d) { return d.keyphrase; })
                    .attr('data-value', function (d) { return scope.rScale(d.value); })
                    .attr('data-change', function (d) { return d.change })
                    .attr('data-type', function (d) { return scope.chartData.type; })
                    .on('click', scope.click)
                    .transition().duration(2000)
                    .attr('r', function(d) {
                        var r = scope.rScale(d.value);
                        this.parentNode.setAttribute('d', r);
                        return r; });

                scope.node
                    .append('text')
                    .attr('dominant-baseline', 'central')
                    .attr('text-anchor', 'middle')
                    .attr('class', 'label')
                    .attr('font-size', function (d) {
                        return (scope.isMaximized) ? scope.fontSizeMaxView : scope.fontSizeDashboardView;
                    })
                    .attr('h', function (d) { return 0;})
                    .on('click', scope.click)
                    .style('font-weight', '400')
                    .style('fill', CoreColorService.colors.grey80)
                    .style('cursor', 'pointer')
                    .attr('data-classname', function (d) { return d.keyphrase; })
                    .attr('data-change', function (d) { return d.change; })
                    .attr('data-type', function (d) { return scope.chartData.type; });

                var label = scope.svg.selectAll('.label');
                if(data.isUpdate){
                    label.selectAll('tspan').remove();
                }

                label.each(function(d) {
                    var words = d.keyphrase.split(' '),
                        wordNum = words.length,
                        j=0, line = [];

                    line[0] = words[0];

                    for (var i=1 ; i < wordNum; i++ ){
                        if ((line[j].length + 1 + words[i].length) > scope.maxLabelLineLength) {
                            j++;
                            line.push(words[i]);
                        }
                        else {line[j] = line[j] + ' ' + words[i];}
                    }

                    for (i=0 ; i <= j; i++ ){
                        d3.select(this).append('tspan')
                            .attr('font-size', function (d) {
                                var fontSize = (scope.isMaximized) ? scope.fontSizeMaxView : scope.fontSizeDashboardView;
                                var height = this.parentNode.getAttribute('h');
                                this.parentNode.setAttribute('h', + height + fontSize );
                                return fontSize;
                            })
                            .text(function (d) { return line[i]; })
                            .attr('x', function (d) { return 0; })
                            .attr('dy', function(d) {
                                    if(i == 0 && j == 0) {
                                        if(Math.abs(d.change) != 100) {
                                            return 0.4 * -0.5 + 'em';
                                        } else {
                                            return '0.4em';
                                        }
                                    } else {
                                        if(i == 0) {
                                            if(Math.abs(d.change) != 100)
                                                return j * -1.5 * (0.5) + 'em'
                                            return j * -1 * (0.5) + 'em'
                                        } else {
                                            return '1.2em';
                                        }
                                    }

                            });
                    }
                });

                label
                    .append('tspan')
                    .text(function (d) {
                        var value = 0;
                        if(d.change == 100 || d.change == -100)
                            return;
                        value = Math.abs((d.change).toFixed(2)).toLocaleString();
                        if(d.change > 0)
                            return "+"  + value + '%';
                        else if(d.change < 0)
                            return "-"  + value + '%';
                        else
                            return value + '%';
                    })
                    .attr('font-size', function (d) {
                        return (scope.isMaximized) ? 12 : 9;})
                    .attr('class', 'volume')
                    .attr('x', function (d) { return 0; })
                    .attr('dy', '1.2em')
                    .style('font-weight', '300')
                    .style('fill', CoreColorService.colors.grey80);

            };


        }],
        link: function (scope, element) {
            scope.selectedNodes = scope.selected;
            function clickOnWordFunc(node) {
                if(scope.selectedNodes.indexOf(node.keyphrase) == -1) {
                    d3.select(this.parentNode).select('circle')
                        .style('fill', CoreColorService.colors.white)
                        .style("stroke", CoreColorService.colors.blueMalibu)
                        .style("stroke-width", 1);
                    scope.selectedNodes.push($(this).attr('data-classname'));
                } else {
                    d3.select(this.parentNode).select('circle')
                        .style('fill', function(d) {
                            if(d.change == -100)
                                return CoreColorService.colors.grey3;
                            return CoreColorService.colors.blueMalibu;
                        })
                        .style('opacity', function(d) {
                            if(d.change != 100 && d.change != -100)
                                return 0.55;
                            return 1.0;
                        })
                        .style('stroke-width', function(d) {
                            if(scope.selected.indexOf(d.keyphrase) > -1)
                                return 1;
                            if(d.change == -100)
                                return 1;
                            return 0;
                        })
                        .style('stroke', function(d) {
                            if(d.change== -100)
                                return CoreColorService.colors.grey20;
                            return 'none';
                        });
                    scope.selectedNodes.splice(scope.selectedNodes.indexOf($(this).attr('data-classname')), 1);
                }
                scope.drill({id:scope.selectedNodes, change:$(this).attr('data-change'), type: $(this).attr('data-type')});
            }

            scope.$on('widgetResized', function(){
                if(!scope.data) {return;}
                scope.createVisualization(scope.chartType,scope.data,element,scope.isMaximized,clickOnWordFunc);

            });
            scope.$watch(function() { return scope.chartData; }, function(data) {

                if(!data) {return;}
                scope.createVisualization(scope.chartType,data,element,scope.isMaximized,clickOnWordFunc);
            });

        }
    };
}]);


angular
    .module('MW.InsDashboard.MomentumWidget',[
        'ContentService',
        'CoreColorService',
        'MW.Framework.TranslationService',
        'MW.Dashboard.DashboardStateService',
        'MW.InsDashboard.insightsBackendService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.CoreBreadcrumb',
        'CoreColorService'])
    .directive('momentumWidget', ['DashboardWidgetService', 'CoreCommon', 'translationService', 'insightsBackendService', 'DashboardChartConfigService', 'InsWidgetConfigService', '$timeout', 'DashboardStateService', '$location', '$routeParams', 'Breadcrumb', 'CoreColorService', 'ContentService', '$filter', '$q',
    function(DashboardWidgetService, CoreCommon, translationService, insightsBackendService, DashboardChartConfigService, InsWidgetConfigService, $timeout, DashboardStateService, $location, $routeParams, Breadcrumb, CoreColorService, ContentService, $filter, $q){
    'use strict';

    var momentumWidget = DashboardWidgetService.getWidget('momentum-widget');

    momentumWidget.maximizedViewFile = 'momentum_widget_max';
    momentumWidget.reportViewFile = 'momentum_widget_report';



    var momentumWidgetController = function($scope){

        var getDefaultEnrichmentTypeFromSettings = function getDefaultEnrichmentTypeFromSettings() {
            return CoreCommon.isUsable($scope.widget.settings.selectedEnrichmentType)?$scope.widget.settings.selectedEnrichmentType.id : $scope.widget.getDefaultEnrichmentType().id;
        };

        var getDefaultChartTypeFromSettings = function getDefaultChartTypeFromSettings() {
            return CoreCommon.isUsable($scope.widget.settings.selectedGraphType)?$scope.widget.settings.selectedGraphType.id : $scope.widget.getDefaultChartType().id;
        };

        $scope.initSettings = function(){
            InsWidgetConfigService.readyWidgetData($scope);
        };

        $scope.toggleEnrichment = function toggleEntichment(enrichmentType) {
            //on toggle we do not want existing click filter to be applied
            if(InsWidgetConfigService.queryRequestSettings.keyphrase){
                InsWidgetConfigService.queryRequestSettings.keyphrase = null;
            }

            if(InsWidgetConfigService.queryRequestSettings.concept) {
                InsWidgetConfigService.queryRequestSettings.concept = null;
            }
            var oldenrichmentType = $scope.enrichmentType;
            $scope.enrichmentType = enrichmentType;
            if (oldenrichmentType !== enrichmentType) {
                $scope.resetBreadcrumb();
                $scope.fetchData();
            }
        };

        if($scope.widget.hasRequiredSettings()){
            $scope.enrichmentType = getDefaultEnrichmentTypeFromSettings();
            $scope.graphType = getDefaultChartTypeFromSettings();
        }

    };

    var momentumWidgetLink = function(scope) {

        scope.widgetIsLoading = false;
        scope.notConfigured = false;
        scope.fetching = false;
        scope.serviceError = false;
        scope.noDataFromServer = false;
        scope.insightsService = 'volumeServices';
        scope.numKeyphrases= 11;
        scope.documentRequest = {};
        scope.selectedNodes = [];

        scope.widget.settings.widgetType = 'momentum';


        /* Bubble styles */
        scope.vanished = {color: CoreColorService.colors.grey3, borderColor: CoreColorService.colors.grey20};
        scope.new = {color: CoreColorService.colors.blueSky, borderColor: 'none'};
        scope.preExisting = {color: CoreColorService.colors.blueLight, borderColor: 'none'};

        /* Fetching words that were stemmed by putting them in this dictionary to take it for drill later on*/
        scope.chartDataDictionary = {};

        var dateStart = null,
            dateEnd = null;

        scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
            var newParams, oldParams, newKeyphrase, oldKeyphrase, type;
            if(newVal == oldVal) {
                return;
            }


            newParams = getRequestParams(newVal);
            oldParams = getRequestParams(oldVal);

            if(newParams.keyphrase || newParams.concept) {
                type = 'keyphrase';
                if(newParams.concept) {
                    type = 'concept';
                }
                newKeyphrase = decodeURI((newParams.keyphrase || newParams.concept).replace(/(%20)/g, ' '));
            }
            if(oldParams.keyphrase || oldParams.concept) {
                oldKeyphrase = decodeURI((oldParams.keyphrase || oldParams.concept).replace(/(%20)/g, ' '));
            }

            updateBreadcrumb(newKeyphrase);

            if(oldKeyphrase !== undefined && newKeyphrase === undefined) {
                scope.documentRequest['keyphrase'] = null;
                scope.documentRequest['concept'] = null;
                InsWidgetConfigService.queryRequestSettings.keyphrase = null;
                InsWidgetConfigService.queryRequestSettings.concept = null;

                //We watch for updateContentStreamQuery on widget_content_stream_maximized.
                if(scope.isMaximized) {
                    scope.updateContentStreamQuery = {
                        name: scope.breadcrumbs && scope.breadcrumbs[scope.breadcrumbs.length - 1].name,
                        query: InsWidgetConfigService.queryRequestSettings
                    };
                } else {
                    scope.$broadcast('contentStream_queryReset', InsWidgetConfigService.queryRequestSettings);
                    scope.$broadcast('contentStream_documentsLoad', InsWidgetConfigService.queryRequestSettings);
                }
            } else if((newKeyphrase !== undefined && oldKeyphrase === undefined) || (newKeyphrase !== undefined && (oldParams.keyphrase !== undefined || oldParams.concept !== undefined) && newKeyphrase !== oldKeyphrase)) {
                scope.loadData().then(function() {
                    var phraseObject = scope.chartData.children.filter(function(object){
                        return object.name == newKeyphrase;
                    })[0];

                    scope.documentRequest['keyphrase'] = null;
                    scope.documentRequest['concept'] = null;
                    InsWidgetConfigService.queryRequestSettings.keyphrase = null;
                    InsWidgetConfigService.queryRequestSettings.concept = null;

                    if(type === 'keyphrase') {
                        scope.documentRequest.keyphrase = scope.chartDataDictionary[newKeyphrase] ? scope.chartDataDictionary[newKeyphrase].join() : newKeyphrase;
                        InsWidgetConfigService.queryRequestSettings['keyphrase'] = newKeyphrase;
                    } else {
                        scope.documentRequest.concept = newKeyphrase;
                        InsWidgetConfigService.queryRequestSettings['concept'] = newKeyphrase;
                    }

                    if(phraseObject != undefined && phraseObject.change != undefined && phraseObject.change == -100) {
                        dateStart = moment(scope.widget.settings.dateRange.absoluteStartDate);
                        dateEnd = moment(scope.widget.settings.dateRange.absoluteEndDate);

                        var duration = dateEnd.diff(dateStart, 'ms');
                        var newDateStart = dateStart.subtract(duration, 'ms');
                        var newDateEnd = scope.widget.settings.dateRange.absoluteStartDate;

                        scope.documentRequest.dateStart = newDateStart.format().toString();
                        scope.documentRequest.dateEnd = newDateEnd;
                    }

                    if(scope.isMaximized) {
                        scope.updateContentStreamQuery = {
                            name: scope.breadcrumbs && scope.breadcrumbs[scope.breadcrumbs.length - 1].name,
                            query: angular.copy(InsWidgetConfigService.queryRequestSettings)
                        };
                        scope.newQuery.query.dateStart = scope.documentRequest.dateStart || scope.newQuery.test.dateStart;
                        scope.newQuery.query.dateEnd = scope.documentRequest.dateEnd || scope.newQuery.test.dateEnd;
                    } else {
                        scope.$broadcast('contentStream_documentsLoad', scope.documentRequest);
                    }
                });
            }
        });

        var getRequestParams = function getRequestParams(url) {
            var params = {};
            var searchStr = url.split("?")[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split("&");
                for(var key in paramsStr) {
                    params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                }
            }
            return params;
        };

        // change indicates whether its an old (= -100) or new (!= -100)
        scope.drill = function drill(keyphrase, change, type){
            if(!keyphrase) {
                return;
            }

            if(scope.isMaximized) {
                var selectedKeyphrases = [];
                var selectedKeyPhrasesbreadcrumb = [];
                for (var i = 0, max = keyphrase.length; i < max; i++) {
                    if(Object.keys(scope.chartDataDictionary).indexOf(keyphrase[i]) > -1)
                        selectedKeyphrases.push(scope.chartDataDictionary[keyphrase[i]].join());
                }
                var queryParams = {};
                if(keyphrase.length > 0) {
                    queryParams['drilled'] = true;
                    if(type == 'keyphrase') {
                        queryParams['keyphrase'] = keyphrase;
                    } else if(type == 'concept') {
                        queryParams['concept'] = keyphrase; //when the clicked bubble is a keyphrase of type concept
                    }
                } else {
                    if(type == 'keyphrase') {
                        queryParams['keyphrase'] = [];
                    } else if(type == 'concept') {
                        queryParams['concept'] = []; //when the clicked bubble is a keyphrase of type concept
                    }
                    queryParams['drilled'] = null;

                }



                updateLocationURL(queryParams);
            }

            scope.$apply(function() {
                scope.documentRequest['keyphrase'] = null;
                scope.documentRequest['concept'] = null;

                if(type == 'keyphrase') {
                    scope.documentRequest.keyphrase = selectedKeyphrases.join();
                } else if(type == 'concept') {
                    scope.documentRequest.concept = selectedKeyphrases.join(); //when the clicked bubble is a keyphrase of type concept
                }

                /* for momentum widget, the daterange for the content stream is not the same as
                 * the chart itself. content stream daterange is twice. starting date is the current
                 * date range duration subtracted from the current starting date
                */

                // Old phrase, document stream should only be searched on the previous date range not current
                if(change == -100) {
                    dateStart = moment(scope.widget.settings.dateRange.absoluteStartDate);
                    dateEnd = moment(scope.widget.settings.dateRange.absoluteEndDate);

                    var duration = dateEnd.diff(dateStart, 'ms');
                    var newDateStart = dateStart.subtract(duration, 'ms');
                    var newDateEnd = scope.widget.settings.dateRange.absoluteStartDate;

                    scope.documentRequest.dateStart = newDateStart.format().toString();
                    scope.documentRequest.dateEnd = newDateEnd;
                }

                scope.$broadcast('contentStream_documentsLoad', scope.documentRequest);
            });

        };

        scope.getDateRange = function(period) {
            var dateStart, dateEnd;
            if(scope.widget.settings.customDateRange) {
                dateStart = scope.widget.settings.dateRange.absoluteStartDate;
                dateEnd = scope.widget.settings.dateRange.absoluteEndDate;
            } else {
                dateStart = DashboardStateService.currentDashboard.currentDateRange.absoluteStartDate;
                dateEnd = DashboardStateService.currentDashboard.currentDateRange.absoluteEndDate;
            }
            if(period == 'current') {
                return $filter('mwConvertDateToUserTimezone')(dateStart, 'mediumDate') + ' - '
                    + $filter('mwConvertDateToUserTimezone')(dateEnd, 'mediumDate');
            }
            else if(period == 'previous') {
                dateStart = moment(scope.widget.settings.dateRange.absoluteStartDate);
                dateEnd = moment(scope.widget.settings.dateRange.absoluteEndDate);
                var duration = dateEnd.diff(dateStart, 'ms');
                var newDateStart = angular.copy(dateStart);
                var newDateStart = moment(dateStart).subtract(duration, 'ms');
                newDateStart = newDateStart.format().toString();
                return $filter('mwConvertDateToUserTimezone')(newDateStart, 'mediumDate') + ' - ' + $filter('mwConvertDateToUserTimezone')(dateStart, 'mediumDate');
            } else {
                return '';
            }
        }

        var updateLocationURL = function updateLocationURL(queryParams) {
            var selectedKeyphrases =  [];
            var keyphrase = queryParams.keyphrase || queryParams.concept;
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            if(!$routeParams.drilled) {
                queryParams['drilled'] = true;
            }

            var urlQuery = {
                editMode:editMode
            };
            for(var prop in queryParams) {
                urlQuery[prop] = queryParams[prop]
            }
            if(queryParams.keyphrase) {
                for(var i = 0, max = keyphrase.length; i < max; i++) {
                    selectedKeyphrases.push(scope.chartDataDictionary[keyphrase[i]].join());
                }
            } else {
                selectedKeyphrases = keyphrase;
            }
            if(selectedKeyphrases.length > 0)
                urlQuery['keyphrase'] = selectedKeyphrases.join();

            updateBreadcrumb(keyphrase);
            $location.path(maxPath).search(urlQuery);
        };

        var updateBreadcrumb = function updateBreadcrumb(keyphrase) {
            var dashboardPath,
            widgetPath,
            selectionTitle = '',
            dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

            scope.breadcrumbs =[];
            scope.breadcrumbs = [Breadcrumb.build({
                name: 'Analyze',
                link: '/analyze/home',
                isClickable: false
            })];
            dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;

            selectionTitle += keyphrase ? keyphrase : '';
            scope.breadcrumbs.push(Breadcrumb.build({name:scope.dashboard.title, link:dashboardPath }));
            if(selectionTitle === '') {
               var mypath = '/dashboard/viewer/'+scope.dashboard._id,
                   subCrumbs = [],
                   myNewPath,
                   subCrumbVal;

                if(scope.dashboard.containers[0].widgets.length > 1) {
                    Object.keys(scope.dashboard.containers[0].widgets).forEach(function(key){
                        myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                        subCrumbVal = {
                            name: scope.dashboard.containers[0].widgets[key].title,
                            link: myNewPath,
                            isClickable: function isClickable() { return true; }
                        };

                        subCrumbs.push(subCrumbVal);
                    });
                }
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, subCrumbs:subCrumbs}));
            } else {
                selectionTitle = decodeURI(selectionTitle);
                widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, link: widgetPath}));
                scope.breadcrumbs.push(Breadcrumb.build({name:selectionTitle}));
            }
        };

        var wasBreadcrumbReset = false;
        scope.resetBreadcrumb = function resetBreadcrumb() {
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            var urlQuery = {
                editMode:editMode
            };
            updateBreadcrumb();
            $location.path(maxPath).search(urlQuery);
            wasBreadcrumbReset = true;
        };

        // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
        scope.$on('widgetFiltersUpdated', function() { scope.fetchData(true); });

        //Content filter in Trending theme and Topic Momentum widgets
        var transformDatapointsToOptions = function transformDatapointsToOptions(enrichmentType, datapoints, numFilterItems){
            var options = [];
            for(var i=0; i < numFilterItems; i++) {
                var o = {};
                o['val'] = datapoints[i][enrichmentType];
                o['name'] = datapoints[i][enrichmentType];
                options.push(o);
            }
            return options;
        };

        scope.loadData = function loadData(isUpdate) {
            var value = null,
                defer = $q.defer();

                scope.chartDataDictionary = {};
                insightsBackendService.consolidatedService.query(scope.documentParams , function(data){
                        var chartData = {},
                            serverData = data.data[0][scope.currentInputId],
                            server_data = serverData.datapoints;
                        chartData.numOfBubbles = (scope.isMaximized) ? 12 : 7;
                        chartData.numOfBubbles = chartData.numOfBubbles > server_data.length ? server_data.length : chartData.numOfBubbles;
                        //Content filter in Trending theme and Topic Momentum widgets
                        ContentService.setOptions(transformDatapointsToOptions(scope.enrichmentType, server_data, chartData.numOfBubbles));
                        if (typeof scope.widget.settings.filteredContent  !== 'undefined') {
                            var filtered_data = [];
                            var term = ''; // keyphrase or concept
                            for ( var i = 0, max = server_data.length; i < max ; i++) {
                                if (typeof server_data[i].keyphrase !== 'undefined') {
                                    term = server_data[i].keyphrase;
                                } else if (typeof server_data[i].concept !== 'undefined') {
                                    term = server_data[i].concept;
                                }
                                if ( scope.widget.settings.filteredContent.indexOf(term) === -1) {
                                    filtered_data.push(server_data[i]);
                                }
                            }
                            server_data = filtered_data;
                        }

                        var serverDataLength = typeof server_data !== 'undefined' ? server_data.length : 0;

                        if (serverDataLength==0){
                            scope.noContent = true;
                        } else {

                        scope.noDataFromServer = false;

                        chartData.children = [];

                        var oldSOV = 0,
                            newSOV = 0;
                        for(var i = 0, max = serverDataLength; i < max; i += 1 ) {

                            var V2 = server_data[i]['newVolume'];
                            var V1 = server_data[i]['oldVolume'];

                            var value = (V2 == 0) ? V1 : V2;

                            oldSOV = server_data[i]['oldSOV'];
                            newSOV = server_data[i]['newSOV'];

                            chartData.type = scope.enrichmentType;




                            var change = 0;
                            if(V1 != 0)
                                change =  (V2 - V1) / V1 * 100;
                            else
                                change = 100;
                            if(scope.enrichmentType == "keyphrase") // Only keyphrases are not unique, So we dont do it for concepts
                                scope.chartDataDictionary[server_data[i][[scope.enrichmentType]]] = server_data[i].related_keyphrases;
                            if(server_data[i]['oldVolume'] == 0)
                                chartData.children.push({'keyphrase':server_data[i][scope.enrichmentType],'value': value, 'change': change, 'oldSOV': oldSOV, 'newSOV': newSOV });
                            else if(server_data[i]['newVolume'] == 0)
                                chartData.children.push({'keyphrase':server_data[i][scope.enrichmentType],'value':value, 'change': change, 'oldSOV': oldSOV, 'newSOV': newSOV });
                            else if(server_data[i]['oldVolume'] < server_data[i]['newVolume'])
                                chartData.children.push({'keyphrase':server_data[i][scope.enrichmentType],'value':value, 'change': change, 'oldSOV': oldSOV, 'newSOV': newSOV });
                            else if(server_data[i]['oldVolume'] > server_data[i]['newVolume'])
                                chartData.children.push({'keyphrase':server_data[i][scope.enrichmentType],'value':value, 'change': change, 'oldSOV': oldSOV, 'newSOV': newSOV });
                            else if(server_data[i]['oldVolume'] == server_data[i]['newVolume'])
                                chartData.children.push({'keyphrase':server_data[i][scope.enrichmentType],'value':value, 'change': change, 'oldSOV': oldSOV, 'newSOV': newSOV });

                        }
                        chartData.oldTotalDocuments = data.oldTotalDocuments;
                        chartData.newTotalDocuments = data.newTotalDocuments;
                        chartData.isMaximized  = scope.isMaximized;
                        scope.chartData = chartData;
                    }
                        scope.widgetIsLoading=false;
                        defer.resolve();
                    },
                    function(){ scope.serviceError=true; scope.widgetIsLoading=false; defer.reject()});
            return defer.promise;
        };

        scope.fetchData = function() {
            scope.initSettings();

            if(!scope.readyToQuery) {return;}

            scope.widgetIsLoading = true;
            scope.serviceError = false;
            scope.noDataFromServer = false;
            scope.notConfigured = false;
            scope.currentInputId = '';

            var baseParams = {
                insObject: 'momentum',
                type: scope.enrichmentType,
                size: scope.numKeyphrases,
                stemming: true
            };


            if(scope.inputs){
                switch (scope.inputs[0].inputType) {
                    case 'rss':
                        baseParams.rssFeeds = [scope.inputs[0].id];
                        scope.currentInputId = scope.inputs[0].id;
                        break;
                    case 'tags':
                        baseParams.tags = [scope.inputs[0].name];
                        scope.currentInputId = scope.inputs[0].name;
                        break;
                    default:
                        baseParams.agents = [scope.inputs[0].id];
                        scope.currentInputId = scope.inputs[0].id;
                        break;
                }

            }else if(scope.searches) {
                scope.currentInputId = scope.searches[0].agent;
                baseParams.agents = [scope.searches[0].agent];
            }

            scope.documentParams = angular.extend(baseParams,scope.chartRequest);

            scope.chartDataObject.insObject = scope.insightsService;

            checkRoutes();
            scope.loadData(false);
        };

        var checkRoutes = function checkRoutes() {
            if($routeParams.keyphrase && !wasBreadcrumbReset) {
                scope.selectedNodes = $routeParams.keyphrase.split(',');
                updateBreadcrumb($routeParams.keyphrase);
            }
        };

        if(scope.widget.hasRequiredSettings()){
            scope.fetchData();
        }
        else {scope.notConfigured=true;}

    };

    return new WidgetDirective(momentumWidget, momentumWidgetLink, momentumWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'CoreCommon', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function(DashboardWidgetService, translationService,CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    'use strict';

    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Topic Momentum'),
        multiDateRange: true, // This hides the default date range and shows the current and previous date range
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Topic Momentum widget is an extension of the Trending Themes widget. ' +
            'It gives insight into key phrases most frequently associated with a brand ' +
            'during a defined period. In addition, it provides a real time comparison to ' +
            'a previous time period, giving you insight into how brand perception changes over time. ' +
            'This widget works best using one input.'),
        directive:'momentum-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            'source': [],
            'maxAgents': 1
        },
        displayOrder: 8,
        allowExport: true,
        requiredSettings: ['dateRange'],
        availableSettings: ['dateRange','title','news','social','broadcast','rss','tags','chartType', 'enrichmentType', 'filteredContent'],
        /* ==== */
        availableEnrichmentTypes: [{name:'Keyphrases',id:'keyphrase'}, {name:'Concepts',id:'concept'}],
        /* ==== */
        availableChartTypes:[{name:'Bubble',id:'bubble'}],
        availableFilters : [{name:'Content',id:'content'},{name:'Country',id:'country'},{name:'Language',id:'language'}],
        getDefaultChartType: function() {
            return this.availableChartTypes[0];
        },
        getDefaultEnrichmentType: function() {
            if (CoreCommon.isUsable(this.settings.searchIds) && this.settings.searchIds.length > 1)
                return this.availableEnrichmentTypes[1];
            else
                return this.availableEnrichmentTypes[0];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);
